<script setup lang="ts">
import { computed } from 'vue'

import { Badge } from '@toni/brand-ui'

export type ProductLabel = { index?: string; text: string; highlight?: boolean; invertText?: boolean }

const props = withDefaults(defineProps<ProductLabel>(), {
  index: '',
  text: '',
  highlight: true,
  invertText: false
})

const hasNumber = computed(() => {
  return props.index ? 'h-[62px] px-3 pt-6 pb-2' : 'h-[54px] p-3'
})

const computedClass = computed(() => ({
  'bg-aside': props.highlight,
  'mt-6': props.index
}))

const invertText = computed(() => {
  return props.invertText ? 'text-accent-tertiary-foreground bg-accent-tertiary px-2 py-1' : 'text-accent-tertiary'
})
</script>

<template>
  <div>
    <div class="flex-col items-center flex"
         :class="computedClass">
      <div v-if="index"
           class="absolute translate-y-[-14px]">
        <Badge type="numeric"
               variant="tertiary"
               size="lg"
               class="text-badge-lg">
          <span class="-rotate-45">{{ index }}</span>
        </Badge>
      </div>
      <div class="flex-col justify-center flex"
           :class="hasNumber">
        <div class="text-badge-lg font-badge text-center uppercase"
             :class="invertText">
          {{ text }}
        </div>
      </div>
    </div>
  </div>
</template>
